module.exports = __webpack_public_path__ + "img/icon_nfc_read_write.1389df9a.svg";